export default __webpack_public_path__ + "static/media/auth-pattern.d31756e2.svg";